import { render, staticRenderFns } from "./MessageInputTools.vue?vue&type=template&id=d2cfcfe2"
import script from "./MessageInputTools.vue?vue&type=script&lang=js"
export * from "./MessageInputTools.vue?vue&type=script&lang=js"
import style0 from "./MessageInputTools.vue?vue&type=style&index=0&id=d2cfcfe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports